import React, { Component } from "react";
import Modal from "react-modal";
import { connect } from "react-redux";
import moment from "jalali-moment/jalali-moment";
import { DatePicker } from "react-advance-jalaali-datepicker";
import { userActions } from "../../_actions";
import { userConstants } from "../../_constants";
import "../../assets/css/happyBirthday.css";
import loadingGif from "../../assets/images/loading.gif";
import { formatDate } from "../../_helpers/formatDate";
Modal.setAppElement("#root");

class HappyBirthday_ extends Component {
  constructor(props) {
    super(props);
    this.state = {
      birthdays: [],
      isLoading: true,
      birthdayModal: false,
      firstName: "",
      lastName: "",
      birthDate: undefined,
      cell_phone: "",
      congratsText: "",
      isEditing: false,
      activeId: null,
      timeZone: "",
    };
    this.globalStorage = this.props.globalStorage;
    this.config = {
      headers: {
        Authorization: JSON.parse(localStorage.getItem("tokenAdmin")),
      },
    };
  }

  componentDidMount = () => {
    this.getBirthDays();
    this.getTimeZone();
  };

  getTimeZone = () => {
    this.props
      .dispatch(userActions.API("get", `v1/time`, null, true, false))
      .then((response) => {
        this.setState({
          timeZone: response.data.split("+")[1],
        });
      })
      .catch((error) => "");
  };

  toUTC = (date) => {
    return moment(date, "jYYYY/jMM/jDD")
      .locale("en")
      .format("YYYY-MM-DDTHH:mm:ss");
    // +
    //   "+" +
    //   this.state.timeZone
  };

  getBirthDays = () => {
    this.props
      .dispatch(
        userActions.API(
          "get",
          `v1/sub_admin/hospital/user_births`,
          null,
          true,
          false,
          JSON.parse(localStorage.getItem("tokenAdmin"))
        )
      )
      .then((res) => {
        this.setState({
          isLoading: false,
          birthdays: res.data.reverse(),
        });
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  postBirthDays = () => {
    const { reset, getBirthDays, toUTC } = this;
    const { firstName, lastName, cell_phone, congratsText, birthDate } =
      this.state;
    const data = {
      firstname: firstName,
      lastname: lastName,
      dob: toUTC(birthDate),
      hbt: congratsText,
      cell_phone,
    };

    this.props
      .dispatch(
        userActions.API(
          "post",
          `v1/sub_admin/hospital/user_births`,
          data,
          true,
          false,
          JSON.parse(localStorage.getItem("tokenAdmin"))
        )
      )
      .then((res) => {
        getBirthDays();
        reset();
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  putBirthDays = () => {
    const { reset, getBirthDays, toUTC } = this;
    const {
      firstName,
      lastName,
      cell_phone,
      congratsText,
      birthDate,
      activeId,
    } = this.state;
    const data = {
      id: activeId,
      firstname: firstName,
      lastname: lastName,
      dob: toUTC(birthDate),
      hbt: congratsText,
      cell_phone,
    };

    this.props
      .dispatch(
        userActions.API(
          "put",
          `v1/sub_admin/hospital/user_births`,
          data,
          true,
          false,
          JSON.parse(localStorage.getItem("tokenAdmin"))
        )
      )
      .then((res) => {
        getBirthDays();
        reset();
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  deleteBirthDays = (id) => {
    const { getBirthDays } = this;

    this.props
      .dispatch(
        userActions.API(
          "delete",
          `v1/sub_admin/hospital/user_births/${id}`,
          null,
          true,
          false,
          JSON.parse(localStorage.getItem("tokenAdmin"))
        )
      )
      .then((res) => {
        getBirthDays();
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  handleDelete = (id) => {
    this.props
      .dispatch(userActions.question("حذف", "آیا از حذف مطمئن هستید؟"))
      .then((r) => {
        if (r.value) {
          this.deleteBirthDays(id);
        }
      });
  };

  handleEdit = (birthday) => {
    const { firstname, lastname, cell_phone, dob, hbt, id } = birthday;

    this.setState({
      birthdayModal: true,
      firstName: firstname,
      lastName: lastname,
      birthDate: formatDate(dob),
      cell_phone: cell_phone,
      congratsText: hbt,
      isEditing: true,
      activeId: id,
    });
  };

  reset = () => {
    this.setState({
      birthdayModal: false,
      firstName: "",
      lastName: "",
      birthDate: undefined,
      cell_phone: "",
      congratsText: "",
      isEditing: false,
      activeId: null,
    });
  };

  render() {
    const { handleDelete, postBirthDays, reset, putBirthDays, handleEdit } =
      this;
    const {
      isLoading,
      birthdays,
      birthdayModal,
      firstName,
      lastName,
      birthDate,
      cell_phone,
      congratsText,
      isEditing,
    } = this.state;
    return (
      <div className="container-fluid px-5 pb-5 mt-3 happyBirthday">
        <div className="row">
          <div className="col-lg-9 col-md-12 m-auto">
            <List onOpen={() => this.setState({ birthdayModal: true })}>
              {isLoading ? (
                <Loading />
              ) : birthdays.length ? (
                birthdays.map((birthday, i) => (
                  <ListItem
                    i={i}
                    key={i + 1}
                    birthday={birthday}
                    onEdit={() => handleEdit(birthday)}
                    onDelete={handleDelete}
                  />
                ))
              ) : (
                <EmptyListItem />
              )}
            </List>
            <Modal
              isOpen={birthdayModal}
              contentLabel="Monitor Modal"
              portalClassName="full_screen_modal"
              className="happyBirthday"
            >
              <ModalPartners
                firstName={firstName}
                lastName={lastName}
                birthDate={birthDate}
                cell_phone={cell_phone}
                congratsText={congratsText}
                onClose={reset}
                isEditing={isEditing}
                onPost={() => (isEditing ? putBirthDays() : postBirthDays())}
                onFirstName={(e) =>
                  this.setState({ firstName: e.target.value })
                }
                onLastName={(e) => this.setState({ lastName: e.target.value })}
                onCellPhone={(e) =>
                  this.setState({ cell_phone: e.target.value })
                }
                onCongratsText={(e, text = null) =>
                  this.setState({
                    congratsText: text !== null ? text : e.target.value,
                  })
                }
                onDate={(unix, formatted) =>
                  this.setState({ birthDate: formatted })
                }
              />
            </Modal>
          </div>
        </div>
      </div>
    );
  }
}

class ModalPartners extends Component {
  componentDidMount = () => {
    document.querySelector(".logout-btn").classList.add("hidden");
    document.querySelector(".logout-btn-bg").classList.add("hidden");
  };

  componentWillUnmount = () => {
    document.querySelector(".logout-btn").classList.remove("hidden");
    document.querySelector(".logout-btn-bg").classList.remove("hidden");
  };

  DatePickerInput(props) {
    return <input type="text" className="form-control" {...props} />;
  }

  render() {
    const {
      firstName,
      lastName,
      birthDate,
      cell_phone,
      congratsText,
      isEditing,
      onClose,
      onPost,
      onFirstName,
      onLastName,
      onCellPhone,
      onCongratsText,
      onDate,
    } = this.props;

    return (
      <div className="modal--add-link birthday_container">
        <div className="row col-lg-12 col-md-12 banner">
          <p>{isEditing ? "تغییر تولد" : "افزودن تولد"}</p>
          <button onClick={onClose}>&#10005;</button>
        </div>

        <div className="d-flex w-100 my-3 flex-wrap px-4">
          <p className=" w-100 text-right px-4 text_style">نام</p>
          <Input
            value={firstName}
            onChange={onFirstName}
            placeholder="نام را انتخاب کنید"
          />
        </div>

        <div className="d-flex w-100 my-3 flex-wrap px-4">
          <p className=" w-100 text-right px-4 text_style">نام خانوادگی</p>
          <Input
            value={lastName}
            onChange={onLastName}
            placeholder="نام خانوادگی را انتخاب کنید"
          />
        </div>

        <div className="d-flex w-100 my-3 flex-wrap px-4">
          <p className=" w-100 text-right px-4 text_style">تاریخ تولد</p>
          <DatePicker
            style={{ fontSize: "13px" }}
            preSelected={birthDate}
            inputComponent={this.DatePickerInput}
            placeholder="انتخاب تاریخ تولد"
            format="jYYYY/jMM/jDD"
            cancelOnBackgroundClick={true}
            onChange={onDate}
            id="edit_date"
          />
        </div>

        <div className="d-flex w-100 my-3 flex-wrap px-4">
          <p className=" w-100 text-right px-4 text_style">شماره همراه</p>
          <Input
            type="number"
            value={cell_phone}
            onChange={onCellPhone}
            placeholder="شماره همراه را انتخاب کنید"
          />
        </div>

        <div className="d-flex w-100 my-3 flex-wrap px-4">
          <p className=" w-100 text-right px-4 text_style">متن تولد </p>
          <Input
            value={congratsText}
            onChange={onCongratsText}
            placeholder="متن تولد را انتخاب کنید"
          />
        </div>

        <div
          style={{ marginBottom: "100px" }}
          className="w-100 d-flex flex-row-reverse align-items-center mt-3 px-4"
        >
          <p className=" w-100 text-right my-0 mx-2 text_style">
            انتخاب متن پیش فرض
          </p>
          <input
            type="checkbox"
            onClick={() =>
              onCongratsText(
                null,
                "تولدت آغاز زیباییهاست زاد روز تولدتان مبارک باد"
              )
            }
          />
        </div>

        <div className="row col-lg-12 footer">
          <button
            onClick={() => {
              if (firstName.length === 0) {
                return userActions.failure("لطفا نام را انتخاب کنید");
              } else if (lastName.length === 0) {
                return userActions.failure("لطفا نام خانوادگی را انتخاب کنید");
              } else if (birthDate === null) {
                return userActions.failure("لطفا تاریخ تولد را انتخاب کنید");
              } else if (congratsText.length === 0) {
                return userActions.failure("لطفا متن تولد را انتخاب کنید");
              }
              onPost();
            }}
          >
            ثبت
          </button>
          <button className="ghost" onClick={onClose}>
            بازگشت
          </button>
        </div>
      </div>
    );
  }
}

class Input extends Component {
  render() {
    const { value, onChange, placeholder, style, type, className } = this.props;
    return (
      <input
        name="name"
        type={type ? type : "text"}
        className={`form-control ${className}`}
        aria-label="Full Name"
        style={style}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
      />
    );
  }
}

class EmptyListItem extends Component {
  render() {
    return (
      <li className="happyBirthday__list__item empty-list">
        <p className="happyBirthday__list__item__text empty-list__child">
          برای نمایش اطلاعات از دکمه های بالا استفاده نمایید
        </p>
      </li>
    );
  }
}

class List extends Component {
  render() {
    const { onOpen } = this.props;

    return (
      <div className="list-wrapper">
        <ul className="happyBirthday__list">
          <Banner />
          {this.props.children}
        </ul>
        <div className="row d-flex justify-content-center align-items-center">
          <button
            class="btn mx-auto btn-primary mt-3 rounded-pill iran-sans_Bold px-5"
            onClick={onOpen}
          >
            افزودن
          </button>
        </div>
      </div>
    );
  }
}

class Banner extends Component {
  render() {
    return (
      <li className="happyBirthday__list__banner" key="0">
        <div className="happyBirthday__list__banner__child">ردیف</div>
        <div className="happyBirthday__list__banner__child">
          نام و نام خانوادگی
        </div>
        <div className="happyBirthday__list__banner__child">تاریخ تولد</div>
        <div className="happyBirthday__list__banner__child">شماره همراه</div>
        <div className="happyBirthday__list__banner__child">متن تولد</div>
        <div className="happyBirthday__list__banner__child">عملیـات</div>
      </li>
    );
  }
}

class ListItem extends Component {
  render() {
    // if (this.props.news === undefined) return null;

    const { i, birthday, onDelete, onEdit } = this.props;
    const { id, firstname, lastname, cell_phone, dob, hbt } = birthday;

    return (
      <li className={`happyBirthday__list__item`}>
        <ListItemBtnContainer>
          <p className="happyBirthday__list__item__text">{i + 1}</p>
        </ListItemBtnContainer>
        <ListItemBtnContainer>
          <p className="happyBirthday__list__item__text">{`${firstname} ${lastname}`}</p>
        </ListItemBtnContainer>
        <ListItemBtnContainer>
          <p className="happyBirthday__list__item__text">{formatDate(dob)}</p>
        </ListItemBtnContainer>
        <ListItemBtnContainer>
          <p className="happyBirthday__list__item__text">{cell_phone}</p>
        </ListItemBtnContainer>
        <ListItemBtnContainer>
          <p className="happyBirthday__list__item__text">
            {hbt.length > 35 ? hbt.slice(0, 25) + "..." : hbt}
          </p>
        </ListItemBtnContainer>
        <ListItemBtnContainer>
          <BtnRound className="edit-icon" onClick={onEdit} />
          <BtnRound className="delete-icon" onClick={() => onDelete(id)} />
        </ListItemBtnContainer>
      </li>
    );
  }
}

class BtnRound extends Component {
  render() {
    return (
      <button
        style={this.props.style}
        className={`btn-round ${this.props.className}`}
        onClick={this.props.onClick}
        data-tip={this.props.data_tip}
      ></button>
    );
  }
}

class ListItemBtnContainer extends Component {
  render() {
    return (
      <div className="happyBirthday__list__item__btn-container">
        {this.props.children}
        {/* <ReactTooltip type="dark" /> */}
      </div>
    );
  }
}

class Loading extends Component {
  render() {
    return (
      <li className="happyBirthday__list__item empty-list">
        <img src={loadingGif} style={{ width: "160px" }} />
      </li>
    );
  }
}

const HappyBirthday = connect((state) => ({
  globalStorage: state.globalStorage,
}))(HappyBirthday_);

export { HappyBirthday };
